import React from 'react';
import { DocumentsDashboardKpis } from '../types';

interface Props {
  kpis: DocumentsDashboardKpis | null;
}

export const DocumentsMetricsCards: React.FC<Props> = ({ kpis }) => {
  if (!kpis) return null;

  return (
    <div className="stats-grid">
      <div className="stat-card">
        <span className="stat-label">Total Documents</span>
        <span className="stat-value" style={{ color: '#2563eb' }}>{kpis.total_documents}</span>
        <span className="stat-sub">{kpis.published_documents} Published / Active</span>
      </div>

      <div className="stat-card">
        <span className="stat-label">In Review & Approval</span>
        <span className="stat-value" style={{ color: '#d97706' }}>
          {kpis.in_review_documents + kpis.pending_approval_documents}
        </span>
        <span className="stat-sub">{kpis.pending_approval_documents} Pending Approval</span>
      </div>

      <div className="stat-card">
        <span className="stat-label">Acknowledgement Rate</span>
        <span className="stat-value" style={{ color: '#059669' }}>
          %{kpis.acknowledgement_compliance_rate}
        </span>
        <span className="stat-sub">Compliance Rate</span>
      </div>

      <div className="stat-card">
        <span className="stat-label">Overdue Reviews</span>
        <span className="stat-value" style={{ color: kpis.overdue_reviews_count > 0 ? '#dc2626' : '#64748b' }}>
          {kpis.overdue_reviews_count}
        </span>
        <span className="stat-sub">{kpis.open_change_requests_count} Open Change Requests</span>
      </div>
    </div>
  );
};
